export default {
    testimonials (state) {
      return state.testimonials
    },

    selectedTestimonial (state) {
        return state.selectedTestimonial
    },

    getTestimonial: state => (testimonialId) => {
      return state.testimonials.find(testimonial => testimonial.testimonialId === testimonialId)
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/testimonials/getters.js